module.exports = __webpack_public_path__ + "assets/img/00006.47af3f4e.png";